import { api_configuration } from "common";
import api_collation_table_decorator = api_configuration.libraries.gui_definition_lib.types.collation_table.alan_api;

export function initializeCollectionTable(raw_collation_table: api_collation_table_decorator.Tcollation_table): void {
	const collation_table = api_collation_table_decorator.Ccollation_table.create(raw_collation_table);
	global.collation_table = collation_table;
	const collation_table_inverse: Record<string, Record<string, unknown>> = {};
	collation_table.properties.characters.forEach(function ($) {
		$.properties.type.switch({
			alternative: function ($) {
				const primary_key = $.properties.for_.entry;
				const alts = collation_table_inverse[primary_key] || {};
				alts[$.parent.key] = {};
				collation_table_inverse[primary_key] = alts;
			},
			primary: function ($) {
				const primary_key = $.parent.key;
				const alts = collation_table_inverse[primary_key] || {};
				alts[primary_key] = {};
				collation_table_inverse[primary_key] = alts;
			},
		});
	});
	global.collation_table_inverse = collation_table_inverse;
}
